var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0258 6.27335C13.2894 6.00989 13.7173 6.00986 13.9809 6.27335C14.2444 6.53691 14.2444 6.96482 13.9809 7.22843L9.48087 11.7284C9.21727 11.992 8.7894 11.992 8.52579 11.7284L4.02579 7.22843C3.76226 6.96482 3.76221 6.53693 4.02579 6.27335C4.28938 6.00989 4.7173 6.00986 4.98087 6.27335L9.00333 10.2968L13.0258 6.27335Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.a5e3294f460a5353f83c952ae721e9c1.svg";
export { ForwardRef as ReactComponent };